export default [
  {
    title: 'Accounting',
    icon: 'chart-line',
    resource: 'Accounting',
    action: 'read',
    children: [
      {
        title: 'Dashboard',
        route: 'AccountingDashboard',
        resource: 'AccountingDashboard',
        action: 'manage',
      },
      {
        title: 'CustomerReceivable',
        route: 'CustomerReceivable3',
        resource: 'CustomerReceivables',
        action: 'manage',
      },
      {
        title: 'SupplierReceivable',
        route: 'SupplierReceivable3',
        resource: 'SupplierReceivables',
        action: 'manage',
      },
      {
        title: 'BankAccounts',
        route: 'BankAccounts',
        resource: 'BankAccounts',
        action: 'manage',
      },
      {
        title: 'VatDeclarations',
        route: 'AccountingVatDeclarations',
        resource: 'AccountingVatDeclarations',
        action: 'manage',
      },
      {
        title: 'Exports',
        route: 'AccountingExports',
        resource: 'AccountingExports',
        action: 'manage',
      }
    ]
  },
]
